import React from 'react'
import Modal from 'react-modal'

const OpenModal = ({isOpen, onClose}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {onClose()}}
      className="bg-white p-6 rounded-lg shadow-lg mx-auto mt-20 relative"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
    >
        {/* ✕ボタン */}
        <button className='absolute top-4 right-4 text-gray-600 text-lg hover:text-gray-800' onClick={() => {onClose()}}>
            <i className='bi bi-x-lg'></i>
        </button>

        <div className='text-center px-6'>
            <h2 className='font-bold text-purple-800 text-xl mb-2'><i className='bi bi-box-seam me-2'></i>ゲームパックを開封しました！</h2>
            <p className='text-gray-600 text-base text-left mb-6'>
                この度は、ご購入ありがとうございました！<br/>
                ぜひ、安全にお楽しみください<br/>
            </p>

            <img src="imgs/undraw_gift_mtlf.svg" alt="open" className='w-64 max-w-100% mx-auto my-4' />
        </div>
    </Modal>
  )
}

export default OpenModal